import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerSearchFocusFieldEnum } from '../../../enum/customer-search-focus-field.enum';
import { DevicePreferenceTypeEnum } from '../../../enum/type/device-preference-type.enum';
import { SquareMeterTypeEnum } from '../../../enum/type/square-meter-type.enum';
import { StorageConstants } from '../../../constant/storage.constant';
import { DevicePreference } from '../../../models/entity/devicePreference';
import { DeviceLocalStorageData } from '../../../models/rest/user/device-local-storage-data.model';
import { AuthService } from '../../../services/auth.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { DeviceService } from '../../../services/store/device.service';
import { CommonConstant } from '../../../constant/common.constant';
import { VoipInternalService } from '../../../services/voip/voip-internal.service';
import { VoipInternalModel } from '../../../models/entity/voip-internal.model';
import { PosDevice } from '../../../models/entity/posDevice';
import { Device } from '../../../models/entity/device';
import { RoleCodeEnum } from '../../../enum/role-code.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VoipInternalAddUpdateComponent } from '../../voip/voip-internal-add-update/voip-internal-add-update.component';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { ModalUtilsService } from '../../../services/core/modal-utils.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { CashRegisterEntity } from '../../../models/entity/cash-register/cash-register-entity';
import { StoreCacheService } from '../../../services/cache/store-cache.service';
import { ArrayUtils } from '../../../utils/array.utils';
import { NumberUtils } from '../../../utils/number.utils';
import { StringUtils } from '../../../utils/string.utils';
import { WhatsappOptionTypeEnumValues } from '../../../enum/common/whatsapp-option-type-enum';

@Component({
  selector: 'app-device-setting-form',
  templateUrl: './device-setting-form.component.html',
  styleUrls: ['./device-setting-form.component.css']
})
export class DeviceSettingFormComponent implements OnInit {
  deviceId;
  devicePreferences: DevicePreference[];
  deviceLocalStorageData: DeviceLocalStorageData = new DeviceLocalStorageData();

  customerSearchFocusFieldEnum = CustomerSearchFocusFieldEnum;
  squareMeterTypeEnum = SquareMeterTypeEnum;
  commonConstant = CommonConstant;
  voipInternals: VoipInternalModel[] = [];
  posDevices: PosDevice[] = [];
  cashRegisters: CashRegisterEntity[] = [];
  paymentTypeIds: number[] = [];
  device: Device = new Device();
  roleCodeEnum = RoleCodeEnum;
  whatsappTypeEnum = WhatsappOptionTypeEnumValues;

  constructor(
    private storeCacheService: StoreCacheService,
    private modalService: NgbModal,
    private sessionStorageService: SessionStorageService,
    private translate: TranslateService,
    private alertifyService: AlertifyService,
    private voipInternalService: VoipInternalService,
    private modalUtilsService: ModalUtilsService,
    private authService: AuthService,
    private deviceService: DeviceService
  ) { }

  ngOnInit(): void {
    this.deviceId = this.authService.getCurrenDeviceId();
    this.getDevicePreferences();
    this.getDevice();
    this.getVoipInternals();
    this.getPosDevices();
    this.getCashRegisters();
    this.getPaymentTypes();
  }

  getDevicePreferences() {
    this.deviceService.getCurrentDevicePreferences(this.deviceId).subscribe(
      res => {
        this.devicePreferences = res;
        this.setValues();
      },
      err => this.alertifyService.error(err)
    );
  }

  getDevice() {
    this.deviceService.getDeviceById(this.deviceId).subscribe(
      res => this.device = res,
      err => this.alertifyService.error(err)
    );
  }

  getVoipInternals() {
    this.voipInternalService.getVoipInternals().subscribe(
      res => this.voipInternals = res,
      err => this.alertifyService.error(err)
    );
  }

  getPosDevices() {
    this.storeCacheService.getPosDevices(this.authService.getStoreId()).subscribe(
      data => {
        this.posDevices = data;
        if (this.posDevices.length == 1)
          this.deviceLocalStorageData.posDeviceId = this.posDevices[0].id;
      },
      err => this.alertifyService.error(err)
    );
  }

  getCashRegisters() {
    this.storeCacheService.getCashRegistersByStoreId(this.authService.getStoreId()).subscribe(
      data => this.cashRegisters = data,
      err => this.alertifyService.error(err)
    );
  }

  getPaymentTypes() {
    this.storeCacheService.getPaymentTypes(this.authService.getStoreId()).subscribe(
      data => {
        this.paymentTypeIds = ArrayUtils.getValuesByKey(data, "id");
        if (NumberUtils.isGreaterThanZero(this.deviceLocalStorageData.deliveryPaymentTypeId) && this.paymentTypeIds.indexOf(this.deviceLocalStorageData.deliveryPaymentTypeId!) == -1)
          this.deviceLocalStorageData.deliveryPaymentTypeId = -1;
        if (NumberUtils.isGreaterThanZero(this.deviceLocalStorageData.newOrderPaymentTypeId) && this.paymentTypeIds.indexOf(this.deviceLocalStorageData.newOrderPaymentTypeId!) == -1)
          this.deviceLocalStorageData.newOrderPaymentTypeId = -1;
      },
      err => this.alertifyService.error(err)
    );
  }

  receiptCountChange(event) {
    this.deviceLocalStorageData.receiptCount = event;
    this.deviceLocalStorageData.isPrintReceipt = NumberUtils.isGreaterThanZero(this.deviceLocalStorageData.receiptCount);
  }

  private setValues() {
    let devicePrefLocalStorageData = this.devicePreferences.find(x => x.shortCode == DevicePreferenceTypeEnum.DEVICE_LOCAL_STORAGE);
    if (devicePrefLocalStorageData && StringUtils.isNotNull(devicePrefLocalStorageData.value))
      this.deviceLocalStorageData = JSON.parse(devicePrefLocalStorageData.value);

    if (this.deviceLocalStorageData?.receiptCount == undefined)
      this.deviceLocalStorageData.receiptCount = 0;
    if (this.deviceLocalStorageData?.newOrderPaymentTypeId == undefined)
      this.deviceLocalStorageData.newOrderPaymentTypeId = -1;
    if (this.deviceLocalStorageData?.deliveryPaymentTypeId == undefined)
      this.deviceLocalStorageData.deliveryPaymentTypeId = -1;
    if (this.deviceLocalStorageData?.squareMeterType == undefined)
      this.deviceLocalStorageData.squareMeterType = SquareMeterTypeEnum.NUMBER_OF_UNIT;
    if (this.deviceLocalStorageData?.orderListRowsPerPage == undefined)
      this.deviceLocalStorageData.orderListRowsPerPage = this.commonConstant.DEFAULT_PRODUCT_PAGE_SIZE;
    if (this.deviceLocalStorageData?.productRowsPerPage == undefined)
      this.deviceLocalStorageData.productRowsPerPage = 40;
    if (this.deviceLocalStorageData?.focusFieldOnCustomerSearch == undefined)
      this.deviceLocalStorageData.focusFieldOnCustomerSearch = CustomerSearchFocusFieldEnum.CUSTOMER_NAME;
    if (this.deviceLocalStorageData?.voipInternalId == undefined)
      this.deviceLocalStorageData.voipInternalId = 0;
    if (this.deviceLocalStorageData?.hasCustomerScreen == undefined)
      this.deviceLocalStorageData.hasCustomerScreen = false;
  }

  validateSave() {
    if (this.deviceLocalStorageData.isVoipActive && (this.deviceLocalStorageData.voipInternalId == undefined || this.deviceLocalStorageData.voipInternalId <= 0)) {
      this.deviceLocalStorageData.isVoipActive = false;
      this.alertifyService.warning(this.translate.instant('message.warning.select-voip-internal-if-voip-is-active'));
      return false;
    }
    return true;
  }

  save() {
    if (!this.validateSave()) return;
    this.sessionStorageService.remove(StorageConstants.DEVICE_LOCAL_STORAGE);
    this.sessionStorageService.setJSONData(StorageConstants.DEVICE_LOCAL_STORAGE, this.deviceLocalStorageData);
    this.updateDevicePreference(DevicePreferenceTypeEnum.DEVICE_LOCAL_STORAGE, JSON.stringify(this.deviceLocalStorageData));
    this.updateDevice();
    this.alertifyService.success(this.translate.instant('message.info.updated'));
  }

  updateDevicePreference(shortCode: string, value: string) {
    let devicePreference = new DevicePreference();
    devicePreference.deviceId = this.deviceId;
    devicePreference.shortCode = shortCode;
    devicePreference.value = value;
    this.deviceService.updateDevicePreference(this.deviceId, devicePreference).subscribe(
      res => { },
      err => this.alertifyService.error(err)
    );
  }

  updateDevice() {
    this.deviceService.updateDevice(this.deviceId, this.device).subscribe(
      res => { },
      err => this.alertifyService.error(err)
    );
  }

  async openVoipInternalAddUpdateModal() {
    const modalRef = this.modalService.open(VoipInternalAddUpdateComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });
    if (NumberUtils.isGreaterThanZero(this.deviceLocalStorageData.voipInternalId)) {
      try {
        const res = await this.voipInternalService.getVoipInternalById(this.deviceLocalStorageData.voipInternalId).toPromise();
        modalRef.componentInstance.data = res;
      } catch {
        this.deviceLocalStorageData.voipInternalId = 0;
      }
    }
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry) this.getVoipInternals();
      modalRef.close();
    });
  }

  async openPrinterSetting() {
    const result = await this.modalUtilsService.openPrinterSettingModal();
    return result;
  }
}
